import { formatDate } from "../../../../utils/DateUtils";
import { convertDoubleToStringPTBR } from "../../../../utils/ConverterUtils";

// Quem pediu o vale. É a coluna que a tela existe para responder, então vem primeiro.
const employeeRenderer = (params) => params.data?.employee?.fullName || '-';

// Valor adiantado, no mesmo formato de moeda do resto do financeiro.
const valueRenderer = (params) => `R$ ${convertDoubleToStringPTBR(params.data?.value || 0)}`;

// Data em que o vale foi entregue, que é a informada pelo gestor e não a de digitação.
const advanceDateRenderer = (params) => params.data?.advanceDate
    ? formatDate(params.data.advanceDate)
    : '-';

const branchRenderer = (params) => params.data?.branch?.name || '-';

// Colunas do grid de vales.
export const Columns = [
	{
		headerName: 'employee',
		field: 'employee.fullName',
		cellRenderer: employeeRenderer,
		sortable: false,
		width: 240
	},
	{
		headerName: 'value',
		field: 'value',
		cellRenderer: valueRenderer,
		width: 140
	},
	{
		headerName: 'date',
		field: 'advanceDate',
		cellRenderer: advanceDateRenderer,
		width: 140
	},
	{
		headerName: 'description',
		field: 'description',
		filter: true
	},
	{
		headerName: 'branch',
		field: 'branch.name',
		cellRenderer: branchRenderer,
		sortable: false,
		width: 180
	},
	{
		headerName: 'status',
		field: 'status',
		type: 'trans',
		width: 120
	}
]
